import type { PositioningPhaseView } from '~/helpers/learner/positioning'
import { Target } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { tourAnchor } from '~/helpers/tour/anchors'

/**
 * L'invitation à se positionner sur l'écran du parcours (#321) : obligatoire à
 * l'entrée, où elle dit pourquoi les modules sont fermés ; facultative à la sortie.
 */
function PositioningCard({ phase, onOpen }: { phase: PositioningPhaseView, onOpen: () => void }) {
  const { t } = useTranslation()
  const key = phase === 'ENTRY' ? 'entry' : 'exit'

  return (
    <section
      className="mb-6 flex flex-col gap-3 rounded-2xl border border-primary/40 bg-card p-5 sm:flex-row sm:items-center sm:justify-between"
      aria-labelledby="positioning-title"
      {...tourAnchor('path.positioning')}
    >
      <div className="flex items-start gap-3">
        <Target className="mt-0.5 size-5 shrink-0 text-primary-text" aria-hidden />
        <div>
          <h2 id="positioning-title" className="font-medium">{t(`positioning.${key}.title`)}</h2>
          <p className="text-sm text-muted-foreground">{t(`positioning.${key}.body`)}</p>
        </div>
      </div>
      <Button onClick={onOpen} className="shrink-0">{t(`positioning.${key}.action`)}</Button>
    </section>
  )
}

export default PositioningCard
